// removed by extract-text-webpack-plugin
module.exports = {"btn":"CaHytAUy9xiiWrB-qTMyr","inline":"_2KfXCROyrbaCisINQTx6SN","primary":"_181YbgFPtGoj5ffoXfc0R-","transparent":"_3ByOVmWEhcu6SdAFyBuZWc","secondary":"_20fx_DiFaHJIr2UU2LfW69","secondaryOutline":"_3TIVCAIr-sz31rJtjFXDf-","spacing-mid":"_3fDq7li9k9e75Gph7ThOf0","light":"_1fjoe5CPGXmkZt8CTNjm56","lightOutline":"_3sk40TKule28oNcRDSLCMe","mid":"iTVK-cngGksjfLtiXnItp","loader":"_2Nm4F6iKyHf04TPJM0dHeg","load8":"_3DOxI8P4J3py8czD8E6RpF","small":"jg1KdcFES5PPb6AIAbso4"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/v2/atoms/Button/style.module.css
// module id = 458
// module chunks = 38